import React, { FC } from 'react';
import { DEFAULT_HEIGHT } from './consts';
import { Skeleton, ISkeletonProps } from './Skeleton';

export const Circle: FC<ISkeletonProps> = ({ radius = DEFAULT_HEIGHT, ...props }) => (
  <Skeleton
    viewBox={`0 0 ${parseInt(radius.toString()) * 2} ${parseInt(radius.toString()) * 2}`}
    width={radius}
    {...props}
  >
    <circle cx={radius} cy={radius} r={radius} />
  </Skeleton>
);
